import * as React from 'react';
import { Icon } from '@unifocus/react-icons';
import { faBars } from '@fortawesome/pro-light-svg-icons';
import { NavBarButton } from './NavBarButton';

/**
 * {@docCategory NavBar}
 */
export interface NavBarMenuButtonProps {
   /**
    * Called when the menu button is clicked.
    */
   onClick: () => void;
}

export const NavBarMenuButton = (props: NavBarMenuButtonProps) => {
   return (
      <NavBarButton onClick={props.onClick} className={'uf-nav-bar-menu-button'}>
         <Icon icon={faBars} className={'uf-nav-bar-menu-button-icon'}/>
      </NavBarButton>
   );
};
